import { WithBillId } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import { getAreAllBillOrderItemsRebated, getAreSomeBillOrderItemsRebated } from '../selectors/orderItems';
import RebatedTag from './RebatedTag';

export const BillRebatedTag = ({ billId }: WithBillId) => {
    const areAllBillOrderItemsRebated = useCommanderSelector((state) =>
        getAreAllBillOrderItemsRebated(state, { billId })
    );

    const areSomeBillOrderItemsRebated = useCommanderSelector((state) =>
        getAreSomeBillOrderItemsRebated(state, { billId })
    );

    if (!areSomeBillOrderItemsRebated) {
        return null;
    }

    return <RebatedTag type={areAllBillOrderItemsRebated ? 'fully' : 'partially'} />;
};
